import TopicLink from './TopicLink';

export default TopicLink;
export * from './TopicLink';
